/* istanbul ignore file */
import React from 'react';
import { Button, ButtonColor, ButtonSize, FormButtonLayoutProps } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import ShadcnCancelButtonLayout from './ShadcnCancelButtonLayout';

function LegacyCancelButtonLayout(props: FormButtonLayoutProps) {
  return (
    <Button
      text={props.text}
      onClick={props.onClick}
      color={ButtonColor.RED}
      size={ButtonSize.BIG}
    />
  );
}

function CancelButtonLayout(props: FormButtonLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnCancelButtonLayout {...props} />;
  } else {
    return <LegacyCancelButtonLayout {...props} />;
  }
}

export default CancelButtonLayout;
